<div class="main">
    <div class="heading">Payment Gateway</div>
    <div class="paymentContainer" *ngFor="let paymentType of paymentOptions" (click)="gatewaySelected(paymentType)">
        <i class="fa fa-credit-card" style="color:#503794" aria-hidden="true"></i>
        <div style="margin-left: 10px;">{{paymentType}}</div>
    </div>
</div>